import React, { createContext, useContext } from "react";

const MultiAccountUiContext = createContext(true);

interface MultiAccountUiProviderProps {
  children: React.ReactNode;
}

export const MultiAccountUiProvider: React.FC<MultiAccountUiProviderProps> = ({
  children,
}) => (
  <MultiAccountUiContext.Provider value>
    {children}
  </MultiAccountUiContext.Provider>
);

export function useMultiAccountUiEnabled(): boolean {
  return useContext(MultiAccountUiContext);
}
